import { PricingSetFragment, RateGroupKindEnum } from '@graphql/platform';

import { PlanName } from '@root/resources/types/plan_name';

const extractLaborEntries = (pricingSet?: PricingSetFragment) =>
  pricingSet?.laborPricingGroupEntries;
const extractPricingGroupEntry = (
  rateGroupName?: RateGroupKindEnum,
  planSize?: PlanName,
  pricingSet?: PricingSetFragment,
) =>
  pricingSet?.storagePricingGroupEntries.find(
    (e) =>
      e.rateGroup?.name === rateGroupName && e.pricing.plan.name === planSize,
  );

export const extractRateGroup = (
  rateGroupName?: string,
  pricingSet?: PricingSetFragment,
) =>
  extractLaborEntries(pricingSet)?.find(
    (entry) => entry.rateGroup?.name === rateGroupName,
  )?.rateGroup ?? undefined;

export const extractLaborPolicy = (
  rateGroupName: string,
  pricingSet?: PricingSetFragment,
) =>
  extractLaborEntries(pricingSet)?.find(
    (entry) => entry.rateGroup?.name === rateGroupName,
  )?.laborPolicy;

export const extractPlan = (
  rateGroupName?: RateGroupKindEnum,
  planSize?: PlanName,
  pricingSet?: PricingSetFragment,
) =>
  extractPricingGroupEntry(rateGroupName, planSize, pricingSet)?.pricing?.plan;

export const extractStoragePrice = (
  rateGroupName?: RateGroupKindEnum,
  planSize?: PlanName,
  pricingSet?: PricingSetFragment,
) =>
  extractPricingGroupEntry(rateGroupName, planSize, pricingSet)?.pricing.amount;
